import Account from "./Account";
import Companies from "./Companies";
import Lists from "./Lists";
import Sales_coach from "./Sales_coach";
import Workspaces from "./Workspaces";
import Integrations from "./Integrations";
import Templates from './Templates';
import Payments from './Payments';
import Deals from './Deals';
import Contacts from './Contacts';
import Analytics from './Analytics';
import Saved_filters from './Saved_filters';
import Folders from './Folders';
import Operational_states from './Operational_states';



import {combineReducers} from 'redux';

const rootReducer = combineReducers({
  account:Account,
  contacts:Contacts,
  deals:Deals,
  integrations:Integrations,
  workspaces:Workspaces,
  templates:Templates,
  payments:Payments,
  sales_coach:Sales_coach,
  analytics:Analytics,
  companies:Companies,
  lists:Lists,
  saved_filters:Saved_filters,
  folders:Folders,
  operational_states:Operational_states
});

export default rootReducer;
